import {transferify} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {PayRequest} from './types';
import type {ActionResponse} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class PaymentDataService {
    public static serviceName = 'paymentDataService';

    public static readonly ROUTE = 'payments/pay';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async pay(payRequest: PayRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${PaymentDataService.ROUTE}`)
            .post(transferify(payRequest));
    }
}
